import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'

interface PropsGetGames {
    authToken: string
    version?: string | null
    is_gamification?: boolean
    retries?: number
    timeout?: number
}

export const request_get_games = async ({ authToken, version, is_gamification = false, retries = 2, timeout = 10 }: PropsGetGames) => {
    const URL = apiUrl + '/oneapp/get_games'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
            is_gamification: is_gamification,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)

        return data.response
    } catch (error) {
    logError('TriviaService', 'request_get_games failed', error)
        return null
    }
}
interface PropsSaveGames {
    authToken: string
    game_id: string
    body: {
        answers: []
        date_start: string
        date_finish: string
    }
    retries?: number
    timeout?: number
    //Gamif
    level_id?: string
    status?: number
}
export const request_save_game = async ({ authToken, game_id, body, retries = 2, timeout = 10, level_id = null, status = null }: PropsSaveGames) => {
    const URL = apiUrl + '/oneapp/save_game'
    try {
        let headers = {}
        headers = {
            Authorization: authToken,
            game_id: game_id,
        }
        if (level_id != null) {
            headers = {
                ...headers,
                level_id: level_id,
                status: status,
            }
        }

        const data = await sendRequest(URL, 'POST', headers, body, retries, timeout)
        return data.response
    } catch (error) {
    logError('TriviaService', 'request_save_game failed', error)
        return null
    }
}
interface PropsGetRanking {
    authToken: string
    version?: string | null
    retries?: number
    timeout?: number
}
export const request_ranking = async ({ authToken, version, retries = 2, timeout = 10 }: PropsGetRanking) => {
    const URL = apiUrl + '/oneapp/ranking'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)
        return data.response
    } catch (error) {
    logError('TriviaService', 'request_ranking failed', error)
        return null
    }
}
